import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('masterVinculations', { startValue: undefined })
  .addVariable('slaveVinculations', { startValue: undefined });
